import React, { Fragment, useEffect, useState } from "react";
import axios from "services/interceptor/Interceptor";
import { toast, ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormSection from "../../formSection/formSection";
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { handleValidateObj } from "constants/objValues/objvalues";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Inventory from "components/sales/inventory/inventory";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { imageUploadUrlPublic } from "services/redux/fileUpload/action";
import Config from "services/config/config";
import * as moment from "moment";
import ModalPop from "../../modal/modal";
import s from "./adjustAdvance.module.css";
import 'react-toastify/dist/ReactToastify.css';

const AdjustAdvancePopup = ({
  showAdjustAdvancePopup,
  onClosePopup = () => { },
  imageUploadUrlPublic,
  businessId,
  invoiceId,
  contractId,
  siteNumber,
  businessName,
  isEdit = false,
  rowData = {},
  isView = false,
}) => {
  const [inputList, setInputList] = useState([
    {
      advance_type: "",
      advance_amt: "",
      amount_to_adjust: isEdit ? rowData?.remarks : isView ? rowData?.finance_remarks : '',
      remark: isEdit ? rowData?.remarks : "",
    },
  ]);
  const [payData, setPayData] = useState();
  const [autoFillData, setAutoFillData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  function handleRemoveAll() {
    setInputList([
      {
        advance_type: "",
        advance_amt: "",
        amount_to_adjust: "",
        remark: "",
      },
    ]);
  }

  const handleConstInput = (e, index, name) => {
    // console.log(e);
    const list = [...inputList];
    list[index][name] = e;
    setInputList(list);
  };

  async function submit() {
    if (parseInt(inputList[0].amount_to_adjust) > autoFillData?.advance_amount) {
      toast.error('Amount to adjust can not be greater than advance amount')
    } else {
      try { 
        setIsLoading(true);
        let url;
        if (isEdit) {
          url = Config.preSalesList.updateAdjustmentRequest;
        } else {
          url = Config.preSalesList.adjustAdvance;
        }
        const payload = {
          request_id: isEdit ? rowData?.request_id : undefined,
          business_id: businessId,
          invoice_id: invoiceId,
          contract_id: contractId,
          site_number: siteNumber,
          amount: inputList[0].amount_to_adjust,
          remark: inputList[0].remark,
        };

        const { data } = await axios.post(url, payload);
        onClosePopup();
        toast.success('Advance Adjustment request submitted successfully');
        handleRemoveAll();
        setIsLoading(false);
      } catch {
        toast.error('Something went wrong, Please try again')
        setIsLoading(false);
      }
    }
  }

  async function fetchAutofillData() {
    try {
      const url = `${Config.preSalesList.adjustAdvanceDetails}?invoice_id=${invoiceId}&contract_id=${contractId}`;

      const { data } = await axios.get(url);
      setAutoFillData(data?.response?.data)
    } catch {
      toast.error('Something went wrong, Please try again')
    }
  }

  useEffect(() => {
    fetchAutofillData();
  }, []);

  const advancePayment = () => {
    return (
      <div className={s.root}>
        {inputList.map((x, i) => {
          return (
            <div>
              <div>
                <h4>Business Name: {businessName}</h4>
                <h4>Site Number: {siteNumber}</h4>
              </div>
              <div className={s.field_combo}>
                <ConstantInput
                  label="Advance Type"
                  type="text"
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      advance_type: val,
                    });
                    handleConstInput(val, i, "advance_type");
                  }}
                  required={true}
                  value={autoFillData?.advance_type}
                  disabled
                />
                <ConstantInput
                  label="Advance Amount"
                  type="number"
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      advance_amt: val,
                    });
                    handleConstInput(val, i, "advance_amt");
                  }}
                  disabled
                  value={autoFillData?.advance_amount?.toString()}
                  required={true}
                />
                <ConstantInput
                  label="Amount to adjust"
                  type="number"
                  disabled={isView}
                  value={isEdit || isView ? rowData?.amount : ''}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      amount_to_adjust: val,
                    });
                    handleConstInput(val, i, "amount_to_adjust");
                  }}
                  required
                  isStarRequired
                />
              </div>
              <br />
              <div className={s.parallel_fields}>
                <ConstantInput
                  label="User Remark"
                  disabled={isView}
                  value={rowData?.remarks || ''}
                  // value={locationData.billGeoState}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      remark: val,
                    });
                    handleConstInput(val, i, "remark");
                  }}
                />
                {isView && <ConstantInput
                    label='Finance Remark'
                    value={rowData?.finance_remark || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />}
              </div>
              <div className={s.parallel_fields}>
                  {isView && <ConstantInput
                    label='Transaction Id'
                    value={rowData?.bank_transaction_id || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />}
                  {isView && <ConstantInput
                    label='ERP Voucher Number'
                    value={rowData?.erp_voucher_number || ''}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />}
                </div>
              {!isView && <>
              <hr style={{ marginTop: '24px' }} />
              <div className={s.button_box}>
                <div className={s.button}>
                  <Button
                    onClick={submit}
                    disabled={isView || isLoading}
                  >
                    {isEdit ? 'Update' :'Submit'}
                  </Button>
                </div>
              </div>
              </>}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <ModalPop
        title={isEdit ? "Edit Advance Adjustment Request" : isView ? "View Advance Adjustment Request" : "Add Advance Adjustment"}
        show={showAdjustAdvancePopup}
        handleModalHide={() => {onClosePopup(); handleRemoveAll()}}
      >
        <Fragment>
          <FormSection>{advancePayment()}</FormSection>
        </Fragment>
      </ModalPop>
    </>
  );
};
AdjustAdvancePopup.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageUploadUrlPublic,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AdjustAdvancePopup);
